module.exports = __webpack_public_path__ + "media/images/logos/logo-works-white-abe15c19bcf700dd1bdd7674ef20c80c.svg";